Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '';
__p += '<img style="width: 100%;" ref="signatureImage">\r\n';
return __p
}